import { application } from "../../../app"

import MainSidebarComponentController from "./main_sidebar_component_controller"
application.register("bo--main-sidebar-component", MainSidebarComponentController)

import SecondarySidebarComponentController from "./secondary_sidebar_component_controller"
application.register("bo--secondary-sidebar-component", SecondarySidebarComponentController)
